(ns ycweb.app.website.cart.pages.reject-saved
  "The save email's \"Wasn't expecting this email?\" page
   (/order.htm?action=RejectSaved&cart_uuid=&r=). Nothing changes on load,
   because email link scanners open every link: the button posts the
   rejection to api.cart.later/cart-reject-saved."
  (:require
   [rum.core :as rum]
   [ycweb.app.website.website :as website]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.flow :as flow]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]))

(rum/defc reject-saved < rum/reactive [app-atom]
  (let [{:keys [result]} (rum/react (cmn/action-cursor app-atom))
        {:keys [cart_uuid r]} (cmn/screen-params app-atom)]
    [:div
     {:class (u/bem :yc-page-content [:standard])}
     [:div
      {:class (u/bem :yc-section [:large])}
      [:div.u-block-center.u-max-width-480
       (headings/heading "Wasn't expecting our email?" {:type :h1 :size :large :center true})
       (cond
         result
         (feedback/feedback (if (:success result) :success :error) (:msg result))

         :else
         [:div
          [:p "We emailed you about a cart saved to your Yuppiechef account. If you didn't save it, someone may have typed your email address by mistake."]
          [:p "Let us know and we'll remove the cart from your account. Our team will look into it."]
          [:div.u-block-center.u-max-width-320
           (buttons/button "Remove this cart from my account"
             #(grid/dispatch-action app-atom :web.order.reject-saved/confirm {:cart_uuid cart_uuid :r r})
             {:raised true
              :full true})]])]]
     (toaster/loading-overlay app-atom :web.cart/reject-saved)]))

(defmethod flow/render-screen :web.order/RejectSaved [app-atom _]
  (website/screen-wrapper app-atom
    (reject-saved app-atom)
    {}))

(defmethod grid/action :web.order.reject-saved/confirm [app-atom params _]
  (toaster/open-overlay app-atom :web.cart/reject-saved)
  (comms/ajax-call :post :web.cart/reject-saved params app-atom {:manual-error-handler? true}))

(defmethod comms/receive :web.cart/reject-saved [app-atom e]
  (toaster/close-overlay app-atom :web.cart/reject-saved)
  (swap! (cmn/action-cursor app-atom) assoc :result (select-keys e [:success :msg])))
